import MenuItem from "@material-ui/core/MenuItem";
import PropTypes from "prop-types";
import MoreMenu from "./MoreMenu";
import { truncateText } from "shared/helper-functions/string/truncateText";
import { useState } from "react";
import { MenuItemLabel, Wrapper } from "./CustomMenuItem.styles";

const CustomMenuItem = ({
    value,
    name,
    owned,
    moreMenuOptions,
    selectedItem,
    onClickItem,
    closeMenu,
}) => {
    const [active, setActive] = useState(false);

    const onItemActive = (_event) => {
        setActive(!active);
    };
    const onItemInactive = (_event) => {
        setActive(false);
    };

    return (
        <Wrapper active={active}>
            <MenuItem
                value={value}
                selected={selectedItem && selectedItem.Id === value}
            >
                <MenuItemLabel onClick={onClickItem}>
                    {truncateText(name, 205)}
                </MenuItemLabel>
                {moreMenuOptions && (
                    <MoreMenu
                        itemId={value}
                        itemName={name}
                        itemOwned={owned}
                        closeParent={closeMenu}
                        onOpen={(e) => onItemActive(e)}
                        onClose={(e) => onItemInactive(e)}
                        portal={true}
                    >
                        {moreMenuOptions}
                    </MoreMenu>
                )}
            </MenuItem>
        </Wrapper>
    );
};

CustomMenuItem.propTypes = {
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
    owned: PropTypes.bool,
    moreMenuOptions: PropTypes.node,
    selectedItem: PropTypes.object,
    onClickItem: PropTypes.func,
    closeMenu: PropTypes.func,
};

export default CustomMenuItem;
